module.exports = __webpack_public_path__ + "static/media/brijlal.fc9146b9.png";